import $ from 'jquery';

$(function() {
    $(document).on('click', '[data-toggle=collapse][data-desktop-target]', function (e) {
        if ($('body').hasClass('screen-lg') || $('body').hasClass('screen-xl')) {
            $($(e.target).attr('data-desktop-target')).closest('.content-block').css('order', '1');
            $('[data-toggle=collapse][data-desktop-target]').not(e.target).each(function (i, el) {
                $($(el).attr('data-desktop-target')).addClass('closing').one('animationend', function (e) {
                    $(this).removeClass('open closing');
                }).closest('.content-block').css('order', '2');
                $(el).removeClass('block-open');
            });

            if ($(e.target).hasClass('block-open')) {
                $($(e.target).attr('data-desktop-target')).addClass('closing').one('animationend', function (e) {
                    $(this).removeClass('open closing');
                });
                $(e.target).removeClass('block-open');
            } else {
                $($(e.target).attr('data-desktop-target')).removeClass('closing').unbind('animationend').addClass('open');
                $(e.target).addClass('block-open');
            }
        };
    });
    
    $(window).on('resize', function (e) {
        if ($('body').hasClass('screen-xs') || $('body').hasClass('screen-sm') || $('body').hasClass('screen-md')) {
            $('.dropdown-nav').removeClass('open closing');
            $('.block-open').removeClass('block-open');
        } else {
            $('header .submenu').removeClass('show');
            $('header .navbar').removeClass('position-fixed');
        }
    });
    $('.submenu').on('show.bs.collapse', function (e) {
        if ($('body').hasClass('screen-lg') || $('body').hasClass('screen-xl')) {
            e.preventDefault();
            return false;
        }
    });
    $('.menu-back').on('click', function (e) {
        $(e.target).closest('div').removeClass('show');
    });

    $(document).on('click', 'header.navigation a:has(.search)', function (e) {
        e.preventDefault();
        $('#search_bar').toggleClass('show');
    })
});